import { useEffect, useMemo, useState } from "react";

function SandboxLeft({
 leftView,
 seasons,
 leagues,
 teams,
 players,
 allPlayers,
 playerGameStats,
 games,
 allTeamsInActiveLeague,
 activeSeason,
 activeLeague,
 activeTeam,
 activeGame,
 onCreateSeason,
 onDeleteSeason,
 onCreateLeague,
 onDeleteLeague,
 onCreateTeam,
 onDeleteTeam,
 onCreatePlayer,
 onDeletePlayer,
 onCreateGame,
 onDeleteGame,
 onSaveFinalScore,
 onSavePlayerStats,
 onOpenSeason,
 onOpenLeague,
 onOpenTeam,
 onOpenGame,
 onGoToSeasons,
 onGoToLeagues,
 onGoToTeams,
 onGoToGames,
 isSeasonLimitReached
}) {
 const [showModal, setShowModal] = useState(false);
 const [draftName, setDraftName] = useState("");

 const [showGameModal, setShowGameModal] = useState(false);
 const [gameForm, setGameForm] = useState({
  date: "",
  homeTeamId: "",
  awayTeamId: "",
  location: "",
  time: "",
 });

 const [showFinalScoreModal, setShowFinalScoreModal] = useState(false);
 const [finalScoreForm, setFinalScoreForm] = useState({
  homeScore: "",
  awayScore: "",
 });

 const [showStatsModal, setShowStatsModal] = useState(false);
 const [statsDraft, setStatsDraft] = useState([]);

 const modalLabel =
  leftView === "seasons"
   ? "Season"
   : leftView === "leagues"
    ? "League"
    : leftView === "teams"
     ? "Team"
     : "Player";

 const availableGameTeams = useMemo(() => {
  return allTeamsInActiveLeague || [];
 }, [allTeamsInActiveLeague]);

 const getTeamName = (teamId) => {
  return (
   availableGameTeams.find((team) => String(team.id) === String(teamId))?.name || ""
  );
 };

 const homeTeamPlayers = useMemo(() => {
  if (!activeGame) return [];
  return (allPlayers || []).filter(
   (player) => String(player.teamId) === String(activeGame.homeTeamId)
  );
 }, [allPlayers, activeGame]);

 const awayTeamPlayers = useMemo(() => {
  if (!activeGame) return [];
  return (allPlayers || []).filter(
   (player) => String(player.teamId) === String(activeGame.awayTeamId)
  );
 }, [allPlayers, activeGame]);

 const gameStats = useMemo(() => {
  if (!activeGame) return [];
  return (playerGameStats || []).filter(
   (item) => String(item.gameId) === String(activeGame.id)
  );
 }, [playerGameStats, activeGame]);

 const getPlayerStat = (playerId) => {
  return (
   gameStats.find((item) => String(item.playerId) === String(playerId)) || {
    pts: 0,
   }
  );
 };

 const buildStatsDraft = () => {
  if (!activeGame) return [];

  const combinedPlayers = [...homeTeamPlayers, ...awayTeamPlayers];

  return combinedPlayers.map((player) => {
   const existing = getPlayerStat(player.id);

   return {
    playerId: player.id,
    pts: existing.pts || 0,
   };
  });
 };

 const getDraftStat = (playerId) => {
  return (
   statsDraft.find((item) => String(item.playerId) === String(playerId)) || {
    pts: 0,
   }
  );
 };

 const updateDraftStat = (playerId, key, value) => {
  setStatsDraft((prev) =>
   prev.map((item) =>
    String(item.playerId) === String(playerId)
     ? { ...item, [key]: value }
     : item
   )
  );
 };
  const getStepHint = () => {
    if (leftView === "seasons") {
      return "Add a season, then click its name to move to the next step.";
    }

    if (leftView === "leagues") {
      return "Add leagues, then click its name to start adding teams to that league.";
    }

    if (leftView === "teams") {
      return "Add teams, then click its name to start adding players to that team";
    }

    if (leftView === "players") {
      return "Add players for this team, then go back to teams to continue building.";
    }

    if (leftView === "gameDetail") {
      return "Edit final scores and player stats for this game here.";
    }

    return "";
  };


 const getTeamTotals = (teamPlayers) => {
  return teamPlayers.reduce(
   (acc, player) => {
    const stat = getPlayerStat(player.id);
    acc.pts += Number(stat.pts) || 0;
    return acc;
   },
   { pts: 0 }
  );
 };
  const formatGameDate = (value) => {
    if (!value) return "—";

    const date = new Date(`${value}T00:00:00`);
    if (Number.isNaN(date.getTime())) return value;

    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    const year = String(date.getFullYear()).slice(-2);

    return `${month}/${day}/${year}`;
  };

 const homeTotals = getTeamTotals(homeTeamPlayers);
 const awayTotals = getTeamTotals(awayTeamPlayers);

  const openModal = () => {
    if (leftView === "seasons" && isSeasonLimitReached) {
      alert("Demo allows 1 season only. Create a free account to unlock more.");
      return;
    }

    setDraftName("");
    setShowModal(true);
  };

 const closeModal = () => {
  setDraftName("");
  setShowModal(false);
 };

 const handleSave = () => {
  if (!draftName.trim()) return;

  if (leftView === "seasons") onCreateSeason(draftName);
  if (leftView === "leagues") onCreateLeague(draftName);
  if (leftView === "teams") onCreateTeam(draftName);
  if (leftView === "players") onCreatePlayer(draftName);

  closeModal();
 };

 const openGameModal = () => {
  setGameForm({
   date: "",
   homeTeamId: "",
   awayTeamId: "",
   location: "",
   time: "",
  });
  setShowGameModal(true);
 };

 const closeGameModal = () => {
  setShowGameModal(false);
 };

  const handleSaveGame = () => {
    if (
      !gameForm.date ||
      !gameForm.homeTeamId ||
      !gameForm.awayTeamId ||
      !gameForm.time
    ) {
      return;
    }

    if (gameForm.homeTeamId === gameForm.awayTeamId) {
      alert("Home team and away team cannot be the same.");
      return;
    }

    onCreateGame({
      ...gameForm,
      location: gameForm.location?.trim() || "",
    });

    closeGameModal();
  };

 const openFinalScoreModal = () => {
  if (!activeGame) return;

  setFinalScoreForm({
   homeScore: activeGame.homeScore ?? 0,
   awayScore: activeGame.awayScore ?? 0,
  });
  setShowFinalScoreModal(true);
 };

 const closeFinalScoreModal = () => {
  setShowFinalScoreModal(false);
 };

 const handleSaveFinalScore = () => {
  if (!activeGame) return;

  onSaveFinalScore({
   gameId: activeGame.id,
   homeScore: finalScoreForm.homeScore,
   awayScore: finalScoreForm.awayScore,
  });

  setShowFinalScoreModal(false);
 };

 const openStatsModal = () => {
  setStatsDraft(buildStatsDraft());
  setShowStatsModal(true);
 };

 const closeStatsModal = () => {
  setShowStatsModal(false);
 };

 const handleSaveStats = () => {
  if (!activeGame) return;

  onSavePlayerStats({
   gameId: activeGame.id,
   stats: statsDraft,
  });

  setShowStatsModal(false);
 };
  const formatGameTime = (value) => {
    if (!value) return "—";

    const [rawHour, rawMinute] = value.split(":");
    const hourNum = Number(rawHour);

    if (Number.isNaN(hourNum) || rawMinute == null) return value;

    const suffix = hourNum >= 12 ? "PM" : "AM";
    const hour12 = hourNum % 12 === 0 ? 12 : hourNum % 12;

    return `${hour12}:${rawMinute} ${suffix}`;
  };
 const renderStatsTable = (teamPlayers, teamLabel, score) => {
  const totals = getTeamTotals(teamPlayers);





  return (
   <div className="sandbox-game-detail-section">
    <h3>
     {teamLabel} ({score})
    </h3>

    <div className="sandbox-admin-table-wrap">
     <table className="sandbox-admin-table">
      <thead>
       <tr>
        <th>Player</th>
        <th>PTS</th>
       </tr>
      </thead>
      <tbody>
       {teamPlayers.length === 0 ? (
        <tr>
         <td colSpan="2" className="sandbox-admin-empty-cell">
          No players yet.
         </td>
        </tr>
       ) : (
        teamPlayers.map((player) => {
         const stat = getPlayerStat(player.id);

         return (
          <tr key={player.id}>
           <td>{player.name}</td>
           <td>{stat.pts || 0}</td>
          </tr>
         );
        })
       )}

       {teamPlayers.length > 0 && (
        <tr className="sandbox-admin-total-row">
         <td>Total</td>
         <td>{totals.pts}</td>
        </tr>
       )}
      </tbody>
     </table>
    </div>
   </div>
  );
 };

 useEffect(() => {
  if (!activeGame) {
   setShowFinalScoreModal(false);
   setShowStatsModal(false);
  }
 }, [activeGame]);

 return (
  <div className="sandbox-left-page">
<div className="sandbox-admin-panel">
  <div className="sandbox-step-hint">
    {getStepHint()}
  </div>
    {leftView === "seasons" && (
     <>
      <div className="sandbox-admin-header sandbox-admin-header-root">
       <h2>SEASONS</h2>
       <button className="sandbox-admin-add-btn" onClick={openModal}>
        + Add Season
       </button>
      </div>

      <div className="sandbox-admin-table-wrap">
       <table className="sandbox-admin-table">
        <thead>
         <tr>
          <th>Name</th>
          <th className="sandbox-admin-delete-col">Delete</th>
         </tr>
        </thead>
        <tbody>
         {seasons.length === 0 ? (
          <tr>
           <td colSpan="2" className="sandbox-admin-empty-cell">
            No seasons yet.
           </td>
          </tr>
         ) : (
          seasons.map((season) => (
           <tr key={season.id}>
            <td>
             <button
              className="sandbox-admin-name-link"
              onClick={() => onOpenSeason(season.id)}
             >
              {season.name}
             </button>
            </td>
            <td className="sandbox-admin-delete-cell">
             <button
              className="sandbox-admin-delete-btn"
              onClick={() => onDeleteSeason(season.id)}
              aria-label={`Delete ${season.name}`}
             >
              🗑️
             </button>
            </td>
           </tr>
          ))
         )}
        </tbody>
       </table>
      </div>
     </>
    )}

    {leftView === "leagues" && (
     <>
      <div className="sandbox-admin-breadcrumb">
       <button className="sandbox-admin-breadcrumb-link" onClick={onGoToSeasons}>
        Seasons
       </button>
       <span>&gt;</span>
       <span className="sandbox-admin-breadcrumb-current">
        {activeSeason?.name}
       </span>
      </div>

      <div className="sandbox-admin-header">
       <button className="sandbox-admin-back-btn" onClick={onGoToSeasons}>
        ←
       </button>

       <button className="sandbox-admin-add-btn" onClick={openModal}>
        + Add League
       </button>
      </div>

      <div className="sandbox-admin-table-wrap">
       <table className="sandbox-admin-table">
        <thead>
         <tr>
          <th>League Name</th>
          <th className="sandbox-admin-delete-col">Delete</th>
         </tr>
        </thead>
        <tbody>
         {leagues.length === 0 ? (
          <tr>
           <td colSpan="2" className="sandbox-admin-empty-cell">
            No leagues yet.
           </td>
          </tr>
         ) : (
          leagues.map((league) => (
           <tr key={league.id}>
            <td>
             <button
              className="sandbox-admin-name-link"
              onClick={() => onOpenLeague(league.id)}
             >
              {league.name}
             </button>
            </td>
            <td className="sandbox-admin-delete-cell">
             <button
              className="sandbox-admin-delete-btn"
              onClick={() => onDeleteLeague(league.id)}
              aria-label={`Delete ${league.name}`}
             >
              🗑️
             </button>
            </td>
           </tr>
          ))
         )}
        </tbody>
       </table>
      </div>
     </>
    )}

    {leftView === "teams" && (
     <>
      <div className="sandbox-admin-breadcrumb">
       <button className="sandbox-admin-breadcrumb-link" onClick={onGoToSeasons}>
        Seasons
       </button>
       <span>&gt;</span>
       <button className="sandbox-admin-breadcrumb-link" onClick={onGoToLeagues}>
        {activeSeason?.name}
       </button>
       <span>&gt;</span>
       <span className="sandbox-admin-breadcrumb-current">
        {activeLeague?.name}
       </span>
      </div>

      <div className="sandbox-admin-header">
       <button className="sandbox-admin-back-btn" onClick={onGoToLeagues}>
        ←
       </button>

       <button className="sandbox-admin-add-btn" onClick={openModal}>
        + Add Team
       </button>
      </div>

      <div className="sandbox-admin-table-wrap">
       <table className="sandbox-admin-table">
        <thead>
         <tr>
          <th>Team Name</th>
          <th className="sandbox-admin-delete-col">Delete</th>
         </tr>
        </thead>
        <tbody>
         {teams.length === 0 ? (
          <tr>
           <td colSpan="2" className="sandbox-admin-empty-cell">
            No teams yet.
           </td>
          </tr>
         ) : (
          teams.map((team) => (
           <tr key={team.id}>
            <td>
             <button
              className="sandbox-admin-name-link"
              onClick={() => onOpenTeam(team.id)}
             >
              {team.name}
             </button>
            </td>
            <td className="sandbox-admin-delete-cell">
             <button
              className="sandbox-admin-delete-btn"
              onClick={() => onDeleteTeam(team.id)}
              aria-label={`Delete ${team.name}`}
             >
              🗑️
             </button>
            </td>
           </tr>
          ))
         )}
        </tbody>
       </table>
      </div>
           <div className="sandbox-subsection-hint">
             Add games for this league below. Make sure there are at least two teams.
           </div>
      <div className="sandbox-admin-subsection">
       <div className="sandbox-admin-header sandbox-admin-subheader">
        <div className="sandbox-admin-subtitle">Games</div>
        <button className="sandbox-admin-add-btn" onClick={openGameModal}>
         + Add Game
        </button>
       </div>

       <div className="sandbox-admin-table-wrap">
        <table className="sandbox-admin-table">
         <thead>
          <tr>
           <th>Date</th>
           <th>Matchup</th>
           <th>Location</th>
           <th>Time</th>
           <th>Status</th>
           <th>Results</th>
           <th className="sandbox-admin-delete-col">Delete</th>
          </tr>
         </thead>
         <tbody>
          {games.length === 0 ? (
           <tr>
            <td colSpan="7" className="sandbox-admin-empty-cell">
             No games yet.
            </td>
           </tr>
          ) : (
           games.map((game) => (
            <tr key={game.id}>
             <td>{formatGameDate(game.date)}</td>
             <td>
              <button
               className="sandbox-admin-name-link"
               onClick={() => onOpenGame(game.id)}
              >
               {getTeamName(game.homeTeamId)} vs {getTeamName(game.awayTeamId)}
              </button>
             </td>
             <td>{game.location}</td>
             <td>{formatGameTime(game.time)}</td>
             <td>{game.status}</td>
             <td>{game.results}</td>
             <td className="sandbox-admin-delete-cell">
              <button
               className="sandbox-admin-delete-btn"
               onClick={() => onDeleteGame(game.id)}
               aria-label="Delete game"
              >
               🗑️
              </button>
             </td>
            </tr>
           ))
          )}
         </tbody>
        </table>
       </div>
      </div>
     </>
    )}

    {leftView === "players" && (
     <>
      <div className="sandbox-admin-breadcrumb">
       <button className="sandbox-admin-breadcrumb-link" onClick={onGoToSeasons}>
        Seasons
       </button>
       <span>&gt;</span>
       <button className="sandbox-admin-breadcrumb-link" onClick={onGoToLeagues}>
        {activeSeason?.name}
       </button>
       <span>&gt;</span>
       <button className="sandbox-admin-breadcrumb-link" onClick={onGoToTeams}>
        {activeLeague?.name}
       </button>
       <span>&gt;</span>
       <span className="sandbox-admin-breadcrumb-current">
        {activeTeam?.name}
       </span>
      </div>

      <div className="sandbox-admin-header">
       <button className="sandbox-admin-back-btn" onClick={onGoToTeams}>
        ←
       </button>

       <button className="sandbox-admin-add-btn" onClick={openModal}>
        + Add Player
       </button>
      </div>

      <div className="sandbox-admin-table-wrap">
       <table className="sandbox-admin-table">
        <thead>
         <tr>
          <th>Player Name</th>
          <th className="sandbox-admin-delete-col">Delete</th>
         </tr>
        </thead>
        <tbody>
         {players.length === 0 ? (
          <tr>
           <td colSpan="2" className="sandbox-admin-empty-cell">
            No players yet.
           </td>
          </tr>
         ) : (
          players.map((player) => (
           <tr key={player.id}>
            <td>{player.name}</td>
            <td className="sandbox-admin-delete-cell">
             <button
              className="sandbox-admin-delete-btn"
              onClick={() => onDeletePlayer(player.id)}
              aria-label={`Delete ${player.name}`}
             >
              🗑️
             </button>
            </td>
           </tr>
          ))
         )}
        </tbody>
       </table>
      </div>
     </>
    )}

    {leftView === "gameDetail" && activeGame && (
     <>
      <div className="sandbox-admin-breadcrumb">
       <button className="sandbox-admin-breadcrumb-link" onClick={onGoToSeasons}>
        Seasons
       </button>
       <span>&gt;</span>
       <button className="sandbox-admin-breadcrumb-link" onClick={onGoToLeagues}>
        {activeSeason?.name}
       </button>
       <span>&gt;</span>
       <button className="sandbox-admin-breadcrumb-link" onClick={onGoToTeams}>
        {activeLeague?.name}
       </button>
       <span>&gt;</span>
       <span className="sandbox-admin-breadcrumb-current">
        {getTeamName(activeGame.homeTeamId)} vs {getTeamName(activeGame.awayTeamId)}
       </span>
      </div>

      <div className="sandbox-admin-header">
       <button className="sandbox-admin-back-btn" onClick={onGoToGames}>
        ←
       </button>

       <div className="sandbox-game-detail-actions">
        <button className="sandbox-admin-action-btn" onClick={openStatsModal}>
         Edit Stats
        </button>
        <button className="sandbox-admin-action-btn" onClick={openFinalScoreModal}>
         Edit Final Scores
        </button>
       </div>
      </div>

      <div className="sandbox-game-detail-meta">
       <div>Location: {activeGame.location}</div>
       <div>Game Time: {activeGame.time}</div>
       <div>Date: {activeGame.date}</div>
      </div>

      {renderStatsTable(
       homeTeamPlayers,
       `Home Team: ${getTeamName(activeGame.homeTeamId)}`,
       activeGame.homeScore ?? 0
      )}

      {renderStatsTable(
       awayTeamPlayers,
       `Away Team: ${getTeamName(activeGame.awayTeamId)}`,
       activeGame.awayScore ?? 0
      )}
     </>
    )}
   </div>

   {showModal && (
    <div className="sandbox-admin-modal-overlay" onClick={closeModal}>
     <div
      className="sandbox-admin-modal"
      onClick={(e) => e.stopPropagation()}
     >
      <h3>Add {modalLabel}</h3>

      <input
       type="text"
       className="sandbox-admin-modal-input"
       placeholder={`${modalLabel} name`}
       value={draftName}
       onChange={(e) => setDraftName(e.target.value)}
       autoFocus
      />

      <div className="sandbox-admin-modal-actions">
       <button className="sandbox-admin-modal-cancel" onClick={closeModal}>
        Cancel
       </button>
       <button className="sandbox-admin-modal-save" onClick={handleSave}>
        Save
       </button>
      </div>
     </div>
    </div>
   )}

   {showGameModal && (
    <div className="sandbox-admin-modal-overlay" onClick={closeGameModal}>
     <div
      className="sandbox-admin-modal sandbox-admin-modal-wide"
      onClick={(e) => e.stopPropagation()}
     >
      <h3>Add Game</h3>

      <div className="sandbox-admin-game-form">
       <input
        type="date"
        className="sandbox-admin-modal-input"
        value={gameForm.date}
        onChange={(e) =>
         setGameForm((prev) => ({ ...prev, date: e.target.value }))
        }
       />

       <select
        className="sandbox-admin-modal-input"
        value={gameForm.homeTeamId}
        onChange={(e) =>
         setGameForm((prev) => ({ ...prev, homeTeamId: e.target.value }))
        }
       >
        <option value="">Select home team</option>
        {availableGameTeams.map((team) => (
         <option key={team.id} value={team.id}>
          {team.name}
         </option>
        ))}
       </select>

       <select
        className="sandbox-admin-modal-input"
        value={gameForm.awayTeamId}
        onChange={(e) =>
         setGameForm((prev) => ({ ...prev, awayTeamId: e.target.value }))
        }
       >
        <option value="">Select away team</option>
        {availableGameTeams.map((team) => (
         <option key={team.id} value={team.id}>
          {team.name}
         </option>
        ))}
       </select>

       <input
        type="text"
        className="sandbox-admin-modal-input"
        placeholder="Location"
        value={gameForm.location}
        onChange={(e) =>
         setGameForm((prev) => ({ ...prev, location: e.target.value }))
        }
       />

       <input
        type="time"
        className="sandbox-admin-modal-input"
        value={gameForm.time}
        onChange={(e) =>
         setGameForm((prev) => ({ ...prev, time: e.target.value }))
        }
       />
      </div>

      <div className="sandbox-admin-modal-actions">
       <button className="sandbox-admin-modal-cancel" onClick={closeGameModal}>
        Cancel
       </button>
       <button className="sandbox-admin-modal-save" onClick={handleSaveGame}>
        Save
       </button>
      </div>
     </div>
    </div>
   )}

   {showFinalScoreModal && activeGame && (
    <div className="sandbox-admin-modal-overlay" onClick={closeFinalScoreModal}>
     <div
      className="sandbox-admin-modal"
      onClick={(e) => e.stopPropagation()}
     >
      <h3>Edit Final Score</h3>

      <div className="sandbox-score-edit-row">
       <label>{getTeamName(activeGame.homeTeamId)}:</label>
       <input
        type="number"
        className="sandbox-admin-modal-input"
        value={finalScoreForm.homeScore}
        onChange={(e) =>
         setFinalScoreForm((prev) => ({
          ...prev,
          homeScore: e.target.value,
         }))
        }
       />
      </div>

      <div className="sandbox-score-edit-row">
       <label>{getTeamName(activeGame.awayTeamId)}:</label>
       <input
        type="number"
        className="sandbox-admin-modal-input"
        value={finalScoreForm.awayScore}
        onChange={(e) =>
         setFinalScoreForm((prev) => ({
          ...prev,
          awayScore: e.target.value,
         }))
        }
       />
      </div>

      <div className="sandbox-admin-modal-actions">
       <button className="sandbox-admin-modal-cancel" onClick={closeFinalScoreModal}>
        Cancel
       </button>
       <button className="sandbox-admin-modal-save" onClick={handleSaveFinalScore}>
        Save Final Score
       </button>
      </div>
     </div>
    </div>
   )}

   {showStatsModal && activeGame && (
    <div className="sandbox-admin-modal-overlay" onClick={closeStatsModal}>
     <div
      className="sandbox-admin-modal sandbox-admin-modal-stats"
      onClick={(e) => e.stopPropagation()}
     >
      <h3>Edit Stats</h3>

      <div className="sandbox-stats-edit-section">
       <h4>{getTeamName(activeGame.homeTeamId)}</h4>
       <table className="sandbox-admin-table">
        <thead>
         <tr>
          <th>Player</th>
          <th>PTS</th>
         </tr>
        </thead>
        <tbody>
         {homeTeamPlayers.map((player) => {
          const stat = getDraftStat(player.id);

          return (
           <tr key={player.id}>
            <td>{player.name}</td>
            <td>
             <input
              type="number"
              className="sandbox-stat-input"
              value={stat.pts}
              onChange={(e) =>
               updateDraftStat(player.id, "pts", e.target.value)
              }
             />
            </td>
           </tr>
          );
         })}
        </tbody>
       </table>
      </div>

      <div className="sandbox-stats-edit-section">
       <h4>{getTeamName(activeGame.awayTeamId)}</h4>
       <table className="sandbox-admin-table">
        <thead>
         <tr>
          <th>Player</th>
          <th>PTS</th>
         </tr>
        </thead>
        <tbody>
         {awayTeamPlayers.map((player) => {
          const stat = getDraftStat(player.id);

          return (
           <tr key={player.id}>
            <td>{player.name}</td>
            <td>
             <input
              type="number"
              className="sandbox-stat-input"
              value={stat.pts}
              onChange={(e) =>
               updateDraftStat(player.id, "pts", e.target.value)
              }
             />
            </td>
           </tr>
          );
         })}
        </tbody>
       </table>
      </div>

      <div className="sandbox-admin-modal-actions">
       <button className="sandbox-admin-modal-cancel" onClick={closeStatsModal}>
        Cancel
       </button>
       <button className="sandbox-admin-modal-save" onClick={handleSaveStats}>
        Save Stats
       </button>
      </div>
     </div>
    </div>
   )}
  </div>
 );
}

export default SandboxLeft;